import React from 'react';
import { ChevronLeft } from 'lucide-react';

// Shared header for the menu and every feature screen. Keep the title, back
// target and optional action in the same positions at every phone width.
export default function SectionHeader({ title, subtitle, onBack, right = null, badge = null, className = '' }) {
  return (
    <header className={`flex items-center gap-2 min-h-[48px] ${className}`}>
      {onBack && (
        <button type="button" onClick={onBack} aria-label="Back"
          className="flex-shrink-0 -ml-2 w-11 h-11 flex items-center justify-center rounded-full text-[#2A1212] hover:bg-[#F3D5B5]/25 transition-colors">
          <ChevronLeft className="w-5 h-5" strokeWidth={2} />
        </button>
      )}
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 min-w-0">
          <h1 className="font-semibold text-[20px] text-[#2A1212] leading-tight truncate">{title}</h1>
          {badge}
        </div>
        {subtitle && <p className="text-[13px] text-[#2A324B]/55 mt-0.5 leading-snug">{subtitle}</p>}
      </div>
      {right && <div className="flex-shrink-0 flex items-center">{right}</div>}
    </header>
  );
}
